import { Button, CircularProgress, useTheme } from "@mui/material";
import { useMediaQuery } from "@uidotdev/usehooks";
import { ReactNode } from "react";

interface Props {
  isLoading: boolean;
  onClick: () => void;
  icon: ReactNode;            // PlayArrow o Stop
  label: string;              // "Start Job" o "Finish Job"
  loadingLabel: string;       // "Starting..." o "Finishing..."
  color?: string;             // color principal
  hoverColor?: string;        // color al hover
}

export const PunchButton = ({
  isLoading,
  onClick,
  icon,
  label,
  loadingLabel,
  color = "#2196f3",
  hoverColor = "#1976d2",
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Button
      variant="contained"
      size={isMobile ? "medium" : "large"}
      startIcon={
        isLoading ? <CircularProgress size={20} color="inherit" /> : icon
      }
      onClick={onClick}
      disabled={isLoading}
      sx={{
        minWidth: isMobile ? "auto" : 160,
        height: 48,
        fontWeight: 600,
        borderRadius: 12,
        backgroundColor: color,
        color: "white",
        textTransform: "none",
        "&:hover": { backgroundColor: hoverColor },
      }}
    >
      {isLoading ? loadingLabel : label}
    </Button>
  );
};
